// extracted by mini-css-extract-plugin
export default {"wrapper":"Final_wrapper__aLLrx","title":"Final_title__puudX","info":"Final_info__2apGS","again-btn":"Final_again-btn__0M3bR"};